
const QuickStats = () => {
  const stats = [
    {
      title: 'Active Projects',
      value: '24',
      change: '+12%',
      changeType: 'increase',
      icon: 'ri-folder-3-line',
      color: 'blue'
    },
    {
      title: 'New Leads',
      value: '18',
      change: '+8%',
      changeType: 'increase',
      icon: 'ri-user-add-line',
      color: 'green'
    },
    {
      title: 'Due This Week',
      value: '7',
      change: '-3%',
      changeType: 'decrease',
      icon: 'ri-calendar-check-line',
      color: 'orange'
    },
    {
      title: 'Completed',
      value: '156',
      change: '+24%',
      changeType: 'increase',
      icon: 'ri-checkbox-circle-line',
      color: 'purple'
    }
  ];

  const getColorClasses = (color: string) => {
    const colors = {
      blue: 'bg-blue-50 text-blue-600',
      green: 'bg-green-50 text-green-600',
      orange: 'bg-orange-50 text-orange-600',
      purple: 'bg-purple-50 text-purple-600'
    };
    return colors[color as keyof typeof colors];
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((stat, index) => (
        <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">{stat.title}</p>
              <p className="text-3xl font-bold text-gray-900 mt-2">{stat.value}</p>
            </div>
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${getColorClasses(stat.color)}`}>
              <i className={`${stat.icon} text-xl`}></i>
            </div>
          </div>
          <div className="mt-4 flex items-center">
            <span className={`text-sm font-medium ${
              stat.changeType === 'increase' ? 'text-green-600' : 'text-red-600'
            }`}>
              {stat.change}
            </span>
            <span className="text-sm text-gray-500 ml-2">from last month</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuickStats;
